// This file is automatically generated during build
export const VERSION = '0.3.0';
export const BUILD_DATE = '20250914';
export const BUILD_TIME = '2025-09-14T10:04:26.497Z';
